export default "__VITE_ASSET__CrJXNc8l__"